import React from "react";
import "../styles/marketing-dashboard.css";

const MarketingContainer = ({ children }) => {
  return (
    <div className="marketing-container flex flex-col bg-transparent">
      {children}
    </div>
  );
};

export default MarketingContainer;
